function parseCompoundEventId(value) {
  if (typeof value !== 'string' || !value.includes('__')) {
    return { baseEventId: value || '', occurrenceId: null };
  }
  const [baseEventId, ...tail] = value.split('__');
  const occurrenceId = tail.join('__') || null;
  return { baseEventId: baseEventId || value, occurrenceId };
}

function toDateSafe(value) {
  if (!value) return null;
  if (typeof value?.toDate === 'function') return value.toDate();
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function isAdminTeamRole(role) {
  const normalized = String(role || '').toLowerCase();
  return normalized === 'admin' || normalized === 'owner';
}

export function buildEventModalStateFromMirrorEvent(calendarEvent) {
  const details = calendarEvent?.details || {};
  const parsedId = parseCompoundEventId(String(calendarEvent?.id || ''));
  const parsedOriginalEventId =
    typeof details.originalEventId === 'string' && details.originalEventId.trim()
      ? parseCompoundEventId(details.originalEventId.trim())
      : { baseEventId: '', occurrenceId: null };
  const explicitEventId =
    parsedOriginalEventId.baseEventId
      ? parsedOriginalEventId.baseEventId
      : typeof details.eventId === 'string' && details.eventId.trim()
        ? parseCompoundEventId(details.eventId.trim()).baseEventId
        : '';
  const parsedDetailsEventId =
    typeof details.eventId === 'string' && details.eventId.trim()
      ? parseCompoundEventId(details.eventId.trim())
      : { baseEventId: '', occurrenceId: null };
  const baseEventId = explicitEventId || parsedId.baseEventId || '';
  const occurrenceId =
    (typeof details.occurrenceId === 'string' && details.occurrenceId.trim()) ||
    parsedOriginalEventId.occurrenceId ||
    parsedDetailsEventId.occurrenceId ||
    parsedId.occurrenceId ||
    null;
  const teamId =
    typeof details.teamId === 'string' && details.teamId.trim()
      ? details.teamId.trim()
      : null;

  if (!teamId || !baseEventId) {
    return { teamId: null, initialData: null };
  }

  const start =
    toDateSafe(calendarEvent?.start) ||
    toDateSafe(details?.start) ||
    (details?.date && details?.time ? toDateSafe(`${details.date}T${details.time}`) : null);
  const durationMinutes = Number(details?.durationMinutes || 60);
  const end =
    toDateSafe(calendarEvent?.end) ||
    toDateSafe(details?.end) ||
    (start ? new Date(start.getTime() + durationMinutes * 60 * 1000) : null);
  const eventMode = details?.eventMode || details?.mode || 'inPerson';

  return {
    teamId,
    initialData: {
      ...details,
      id: baseEventId,
      originalId: baseEventId,
      originalEventId: baseEventId,
      occurrenceId,
      title: calendarEvent?.title || details?.name || details?.title || 'Event',
      name: details?.name || details?.title || calendarEvent?.title || 'Event',
      start,
      end,
      mode: eventMode,
      eventMode,
      onlineUrl: details?.onlineUrl || '',
      attendanceMode: details?.attendanceMode || 'none',
      location: details?.location || {},
      readOnly: false,
    },
  };
}
